import { matchPath, useLocation } from 'react-router-dom';

import Text from '@zenbusiness/zui/Text';

import { AFFILIATE_DISCLOSURE_TEXT, DISCLOSURE_TEXT } from '#client/constants';
import * as ROUTES from '#client/constants/routes';

const DISCLOSURE_ROUTES = [ROUTES.entity];

export function DisclosureText() {
  const { pathname } = useLocation();

  const shouldDisplayDisclosure = DISCLOSURE_ROUTES.some((route) => {
    const match = matchPath(route, pathname);
    return match !== null;
  });

  if (!shouldDisplayDisclosure) {
    return null;
  }

  return <Text size="xs">{`${DISCLOSURE_TEXT} ${AFFILIATE_DISCLOSURE_TEXT}`}</Text>;
}
